import type { GameDto } from '@brig/api-types';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { queryKeys } from '../api/hooks.ts';
import { ServerGame } from '../game/ServerGame.tsx';

/** `/games/:id`: one of the captain's games, full screen. */
export function Game() {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const onSwitch = useCallback(
    (game: GameDto) => {
      queryClient.setQueryData(queryKeys.game(game.id), game);
      void queryClient.invalidateQueries({ queryKey: queryKeys.myGames });
      void navigate(`/games/${game.id}`);
    },
    [navigate, queryClient],
  );
  return <ServerGame id={id} onSwitch={onSwitch} title={t('app.shortName')} />;
}
